const carouselData = [
  {
    title: '年度十大娱乐圈大事件盘点',
    desc: '从年初的顶流塌房到年末的世纪复合，今年娱乐圈发生了太多让人意想不到的大事...',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20collage%20style%20of%20entertainment%20headlines%20and%20news%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20modern%20magazine%20layout%20aesthetic%2C%20abstract%20newsroom%20vibe%2C%20professional%20quality&width=1200&height=600&seq=carousel-feature-01&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '热门综艺《明星大挑战》深度解析',
    desc: '为什么这档综艺能成为今年的现象级节目？从嘉宾阵容到环节设计全方位解读...',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20production%20behind%20scenes%20with%20warm%20stage%20lighting%2C%20creative%20atmosphere%2C%20soft%20coral%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20professional%20TV%20studio&width=1200&height=600&seq=carousel-feature-02&orientation=landscape',
    tag: '深度解析',
  },
  {
    title: '娱乐圈"清朗行动"最新进展追踪',
    desc: '持续关注娱乐圈整治行动的最新动态，多位艺人工作室被约谈，行业规范进一步收紧...',
    image: 'https://readdy.ai/api/search-image?query=Professional%20newsroom%20with%20warm%20ambient%20light%2C%20clean%20modern%20workspace%2C%20abstract%20journalism%20theme%2C%20beige%20and%20warm%20gray%20tones%2C%20editorial%20quality&width=1200&height=600&seq=carousel-feature-03&orientation=landscape',
    tag: '行业观察',
  },
  {
    title: '某知名品牌代言人风波始末',
    desc: '从官宣代言到紧急解约只用了72小时，这场品牌代言风波为何引发如此巨大的争议...',
    image: 'https://readdy.ai/api/search-image?query=Brand%20endorsement%20concept%20with%20elegant%20warm%20lighting%2C%20luxury%20product%20photography%20style%2C%20soft%20coral%20and%20cream%20background%2C%20editorial%20quality%2C%20sophisticated%20atmosphere&width=1200&height=600&seq=carousel-feature-04&orientation=landscape',
    tag: '品牌风波',
  },
  {
    title: '选秀节目背后的资本游戏揭秘',
    desc: '深入解读选秀节目制作背后的商业逻辑，从选手包装到粉丝经济，资本如何操控舆论...',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20business%20concept%20with%20warm%20lighting%2C%20modern%20office%20meeting%20room%2C%20abstract%20corporate%20aesthetic%2C%20coral%20and%20beige%20tones%2C%20editorial%20quality&width=1200&height=600&seq=carousel-feature-05&orientation=landscape',
    tag: '资本揭秘',
  },
  {
    title: '粉丝文化变迁：从追星到参与造星',
    desc: '深度分析当下粉丝文化的演变趋势，粉丝已经从单纯的消费者转变为产业链的重要一环...',
    image: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20at%20a%20fan%20event%20with%20warm%20atmosphere%2C%20concert%20light%20sticks%2C%20emotional%20connection%2C%20soft%20coral%20and%20warm%20tones%2C%20documentary%20style&width=1200&height=600&seq=carousel-feature-06&orientation=landscape',
    tag: '文化观察',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-focus-2-line text-primary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">焦点专题</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">精选深度专题内容，多角度解读热门事件</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article
              key={item.title}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer group flex flex-col"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col gap-2">
                <h3 className="font-heading font-bold text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium mt-1 inline-flex items-center gap-1">
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}